<script>
    import jQuery from "jquery";
    import {GPContextTexture, rotationStore as rotation, zoomStore as zoom, activeTextureStore,
        hsvHStore,
        hsvSStore,
        hsvVStore} from "./gp-context-texture.js";
    import { onMount } from 'svelte';

    let ready = false;
    let elemsInRow = null;
    export let textures;
    $: cssHSVStyle = "filter: hue-rotate("+$hsvHStore+"deg) saturate("+(1+$hsvSStore / 3)+") brightness("+(1+$hsvVStore / 3)+")";

    onMount(() => {
        textures = textures.sort((a,b) => a.enabled > b.enabled ? (a.id<b.id? 1 : -1) : 1);

        jQuery(window).off('resize', onResize);
        jQuery(window).on('resize', onResize);
        onResize();
    })

    export function selectFirstItem() {
        selectItem(textures[0]);
        scrollToSelected();
    }

    function selectItem(texture) {
        if (texture.enabled) {
            $activeTextureStore = texture;
        } else
            GPSettings.upgradeClass.showOnlyInPremium("textures")
    }

    function scrollToSelected() {
        setTimeout(() => {
            let el = jQuery('.GPTexturePickerItem.selected');
            if (el) {
                let main = jQuery("#GPTexturePickerList");
                let top = jQuery(".GPTexturePickerItem").eq(0).parent().position().top;
                let t = el.position().top;
                main.animate({scrollTop: -top + t}, 100);
            }
        }, 1)
    }

    function selectNextItem(step) {
        let displayedObjs = textures.filter((e)=>e.enabled);
        let newActiveIndex = displayedObjs.indexOf($activeTextureStore) + step;
        if (newActiveIndex >= displayedObjs.length) newActiveIndex = displayedObjs.length - 1;
        $activeTextureStore = displayedObjs[newActiveIndex];
        scrollToSelected();
    }

    function selectPrevItem(step) {
        let displayedObjs = textures.filter((e)=>e.enabled);
        let newActiveIndex = displayedObjs.indexOf($activeTextureStore) - step;
        if (newActiveIndex < 0) newActiveIndex = 0;
        $activeTextureStore = displayedObjs[newActiveIndex];
        scrollToSelected();
    }

    function handleKeyboard(e) {
        if (!$activeTextureStore || !(jQuery(".GPPickerArea.active").length)) return;
        switch(e.which) {
            case 37: // left
                selectPrevItem(1);
            break;

            case 38: // up
                selectPrevItem(elemsInRow);
            break;

            case 39: // right
                selectNextItem(1);
            break;

            case 40: // down
                selectNextItem(elemsInRow);
            break;

            case 32: // space
                GP.storeFocus();
                GPContextTexture.setupTextureCursor();
                jQuery('.GPProjectView').focus();
            break;

            default: return; // exit this handler for other keys
        }
        e.preventDefault(); // prevent the default action (scroll / move caret)
    }
    
    function resetPicker(omitDefault) {
        selectFirstItem();
    }
    
    export function onResize() {
        var pickerW = jQuery('.GPPickerArea').innerWidth();
        elemsInRow = Math.floor(pickerW / 110);
        jQuery('#GPTexturePicker .list-group').css('grid-template-columns', 'repeat(' + elemsInRow + ', 1fr)');
    }        

</script>

<svelte:window on:keydown={handleKeyboard} on:GPNewProject={resetPicker}/>


{#each textures as texture (texture.id)}
    <li on:click={() => selectItem(texture)}
        role="button"
        class:rotated={$activeTextureStore===texture && $rotation != 0}
        class:selected={$activeTextureStore===texture}
        class="list-group-item GPTexturePickerItem {texture.enabled?'enabled':'premiumDisabled'}"
        GPItem="{texture.id}">
            {#if $activeTextureStore===texture && ($rotation != 0 || $zoom !=1)}
            <div class="GPTexturePickerPreview" style="{cssHSVStyle}">
                <div class="GPTexturePickerImage" style='background-size: {30*Math.sqrt($zoom)}%; {"background-image:url(\"" + texture.thumbSrc.replaceAll("\\","/") +"\")"} ;transform: rotate({-$rotation}rad);'></div>
            </div>
            {:else}
            <img alt="" src="{texture.thumbSrc}" style="{$activeTextureStore===texture ? cssHSVStyle : ''}"/>
            {/if}
            <div class="GPTexturePickerItemName">{texture.name}</div>
    </li>
{/each}


